import React, { Fragment, useCallback, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import { Button, Menu, MenuItem, TableHead } from "@material-ui/core";
import Loading from "../Loading/Loading";
import SettingIcon from "../../Assets/Icons/setting-2.png";
// import { Placeholder } from "../../Middleware/CommonFun";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "../Dropdown/Dropdown";
import ScanIcon from "../../Assets/Icons/scans.png";
import { BASEURI } from "../../Middleware/axiosInstance";
import { IMAGE_URI } from "../../Actions/AuditActions";
import { Delete } from "@mui/icons-material";
import meeshoIcon from "../../Assets/Icons/meesho.png";
import myntraIcon from "../../Assets/Icons/myntra.png";
import snapdealIcon from "../../Assets/Icons/snapdeal.png";
import flipkartIcon from "../../Assets/Icons/flipkart.png";
import amazonIcon from "../../Assets/Icons/amazon.png";

const Menu_arr = [
  {
    id: 1,
    title: "View Details",
  },
  {
    id: 2,
    title: "Approve Now",
  },
  {
    id: 3,
    title: "Start Audit",
  },
  {
    id: 4,
    title: "Completed",
  },
  {
    id: 5,
    title: "View Media",
  },
];

const OPTION_ARR = [
  {
    id: 1,
    value: "true",
    label: "Yes",
  },
  {
    id: 2,
    value: "false",
    label: "No",
  },
];

const DataTable = React.memo(
  ({
    header,
    manufacturing_data,
    previous_Boxes,
    handleDownloadBoxLabel,
    download_box_label_loading,
    handleProducts,
    products,
    basicQuantity,
    detailsData_arr,
    sizeColor_dataArr,
    isObject,
    // defects__data,
    handleMedia,
    general__data,
    inspectionPoints,
    // fileInputRef,
    handleInputChange,
    handleFileChange,
    is_measurement,
    handleChangeInspectionStatus,
    batch_size,
    eval_defect,
    items_per_page,
    page,
    handleBatchIds,
    newBatchIds,
    isMeasurement_table,
    rowEvalDefects,
    PreviousSerial_Data,
    handleNotify,
    setIsIndex,
    setModalId,
    handlePickToggle,
    CuttingSummaryData,
    EstimationData,
    handleCutDelete,
    delLoading,
    modalId,
    viewcad,
    viewcomment,
    handleDownloadLabel,
    setManufactureOrderId,
    challan_data,
    handleDeleteChallan,
    deleteChallan__loading,
    isActiveChallan,
    MasterData,
    onDeleteAction,
    selectedRow,
    scannable_loading,
    batches,
    handleBatchDetails,
    batchDetails,
    handleMarkHold,
    activeMarkHoldIndex,
    markHoldLoading,
    productConsolidatedReport,
    operationTypeMap,
    hourlyConsolidatedReport,
    subOrderSummary,
    TempHoldSummary,
    handleDeactivate,
    tempHold__Loading,
    isActiveTemp,
    portalNetInventory,
    suborderLevelViewConsolidated,
    dynamicSubOrderCols,
    activeProduct,
    handleAlternateModal,
    alternateSKU,
    missingInventoryList,
    handlePortalInventPopup,
    PortalNetInventPopup,
  }) => {
    const navigate = useNavigate();
    const [isActiveIndex, setIsActiveIndex] = useState("");

    const baseDomain = BASEURI.split("/")[0] + "//" + BASEURI.split("/")[2];

    // Master Cut Component starts here
    // const [viewOptions, setViewOptions] = useState(false);
    // const [iIndex, setiIndex] = useState(0);

    // Master cut component ends here

    const DownloadBoxLabel = (i, id) => {
      setIsActiveIndex(i);
      handleDownloadBoxLabel(id);
    };

    const handleViewSku = (id) => {
      handleProducts(id);
    };

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [batch_id, setBatchId] = useState("");
    const [inspection_status, setInspection_status] = useState("");

    const handleClick = useCallback((event, batch_id, status) => {
      // console.log("status: ", status);
      setAnchorEl(event.currentTarget);
      setBatchId(batch_id);
      setInspection_status(status);
    }, []);

    const handleClose = (id, batc_id) => {
      if (id === 5) {
        return navigate(`/qualitymanager/view-media/${batch_id}`);
      }
      if (id === 1) {
        return navigate(`/qualitymanager/view-details/${batch_id}`);
      }
      if (id === 3) {
        handleChangeInspectionStatus(3, batc_id);
        return;
      }
      if (id === 4) {
        handleChangeInspectionStatus(4, batc_id);
        return;
      }
      if (id === 2) {
        handleChangeInspectionStatus(2, batc_id);
        return;
      }
      setAnchorEl(null);
    };

    const [focusedInput, setFocusedInput] = useState(null);

    // console.log("sizeColor_dataArr", sizeColor_dataArr);

    const [openRowIndex, setOpenRowIndex] = useState(null);

    console.log("subOrderSummary", hourlyConsolidatedReport);

    const categoryColors = {
      Fresh: "#1976d2", // Blue
      Alter: "#2e7d32", // Green
      Mending: "#f9a825", // Yellow
      Stained: "#d32f2f", // Red
    };

    return (
      <Fragment>
        <TableContainer>
          <Table className="table" aria-label="dynamic table">
            {/* Table Head */}
            <TableHead>
              {productConsolidatedReport ? (
                <>
                  {/* -------- First Row → Categories -------- */}
                  <TableRow>
                    <TableCell rowSpan={2} className="first__header__row">
                      {activeProduct}
                    </TableCell>
                    <TableCell rowSpan={2}>Date</TableCell>

                    {header?.mainRow?.map((cat, index) => (
                      <TableCell
                        key={index}
                        className="header__row"
                        align="center"
                        colSpan={cat.colSpan}
                        style={{
                          backgroundColor: categoryColors[cat.label],
                        }}
                      >
                        {cat.label}
                      </TableCell>
                    ))}
                  </TableRow>

                  {/* -------- Second Row → Operations -------- */}
                  <TableRow>
                    {header?.subRow?.map((op) => (
                      <TableCell
                        key={op.id}
                        className="header__row__new"
                        sx={{
                          backgroundColor: "#e3f2fd",
                          fontWeight: 500,
                        }}
                      >
                        {op.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </>
              ) : (
                /* -------- Old / Flat header fallback -------- */
                <TableRow>
                  {header?.map((i, index) => (
                    <TableCell key={index}>
                      {typeof i === "object" && i !== null && "value" in i
                        ? i.value
                        : i}
                    </TableCell>
                  ))}
                </TableRow>
              )}
            </TableHead>

            {/* Table Head */}
            <TableBody>
              {/* Manufacturing Packaging Table component starts here */}
              {manufacturing_data &&
                manufacturing_data.map((i, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{i?.serial_code}</TableCell>
                    <TableCell>
                      <img className="icon-picture" src={i?.image} alt="" />
                    </TableCell>
                    <TableCell>{i?.sku}</TableCell>
                    <TableCell>{i?.product_group}</TableCell>
                    <TableCell>
                      <Button
                        onClick={() =>
                          onDeleteAction(i?.serial_code, index, i?.log_id)
                        }
                        className="delete__cta"
                      >
                        {selectedRow === index && scannable_loading ? (
                          <Loading
                            loading={scannable_loading}
                            color={"white"}
                            size={14}
                          />
                        ) : (
                          <Delete />
                        )}
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              {/* Manufacturing Packaging Table component ends here */}
              {/* Previous Boxes Table Component starts here */}
              {previous_Boxes &&
                previous_Boxes.map((i, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{i?.id}</TableCell>
                    <TableCell>{i?.box_no}</TableCell>
                    <TableCell>{i.qty}</TableCell>
                    <TableCell>{i?.created_by}</TableCell>
                    <TableCell>{i?.created}</TableCell>
                    <TableCell>
                      <div className="previous-box-cta">
                        <Button onClick={() => DownloadBoxLabel(index, i.id)}>
                          {download_box_label_loading &&
                          index === isActiveIndex ? (
                            <Loading loading={download_box_label_loading} />
                          ) : (
                            "Download Label"
                          )}
                        </Button>
                        <br />
                        <Button onClick={() => handleViewSku(i.id)}>
                          View SKU
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              {/* Previous Boxes Table Component ends here */}
              {/* Products Table Component starts here */}
              {products &&
                products?.map((i, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{i?.sku}</TableCell>
                    <TableCell>
                      <img className="icon-picture" src={i?.image} alt="" />
                    </TableCell>
                    {/* <TableCell></TableCell> */}
                    <TableCell>{i.qty}</TableCell>
                    {/* <TableCell></TableCell> */}
                  </TableRow>
                ))}
              {/* Products Table Component ends here */}
              {/* Basic Quantity Table Component starts here */}
              {Array.isArray(basicQuantity) &&
                basicQuantity?.map((i, index) => {
                  // console.log("NEW BATCH IDSX: ", newBatchIds);
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>
                        {parseInt(i?.batch?.random_inspection_status) ===
                        3 ? null : (
                          <label
                            onChange={() => handleBatchIds(i?.batch?.batch_id)}
                          >
                            <input
                              type="checkbox"
                              checked={
                                newBatchIds.includes(i?.batch?.batch_id)
                                  ? true
                                  : false
                              }
                            />
                          </label>
                        )}{" "}
                        {(page - 1) * items_per_page + index + 1}
                      </TableCell>
                      <TableCell>
                        <img
                          className="icon-picture"
                          src={`${IMAGE_URI}/image?link=${i?.batch?.product_group_image}`}
                          alt=""
                        />
                      </TableCell>
                      <TableCell>
                        ({i?.batch?.batch_id}) - {i?.batch?.batch_name}
                      </TableCell>
                      <TableCell>{i.batch?.product_group_name}</TableCell>
                      <TableCell>{i?.batch?.batch_qty}</TableCell>
                      {/* <TableCell>
                      {i?.manufacture_color_ratio?.length > 0 && (
                        <>
                          Color →{" "}
                          {i.manufacture_color_ratio
                            .map((i) => `${i.code}: ${i.ratio}`)
                            .join(", ")}
                          <br />
                        </>
                      )}
                      {i?.manufacture_size_ratio?.length > 0 && (
                        <>
                          Size →{" "}
                          {i.manufacture_size_ratio
                            .map((i) => `${i.code}: ${i.ratio}`)
                            .join(", ")}
                        </>
                      )}
                    </TableCell> */}

                      <TableCell>
                        {i?.manufacture_color_ratio?.length > 0 && (
                          <>
                            Color →{" "}
                            {i.manufacture_color_ratio.map((item, index) => (
                              <React.Fragment key={index}>
                                {item.code}: {item.ratio}
                                {(index + 1) % 3 === 0 && <br />}
                                {index !==
                                  i.manufacture_color_ratio.length - 1 && ", "}
                              </React.Fragment>
                            ))}
                            <br />
                          </>
                        )}
                        {i?.manufacture_size_ratio?.length > 0 && (
                          <>
                            Size →{" "}
                            {i.manufacture_size_ratio.map((item, index) => (
                              <React.Fragment key={index}>
                                {item.code}: {item.ratio}
                                {(index + 1) % 3 === 0 && <br />}
                                {index !==
                                  i.manufacture_size_ratio.length - 1 && ", "}
                              </React.Fragment>
                            ))}
                          </>
                        )}
                      </TableCell>

                      <TableCell>
                        {i?.batch?.minimum_qty_to_be_inspected}
                      </TableCell>
                      <TableCell>
                        {i?.defects?.map((j, _index) => (
                          <Fragment key={_index}>
                            <p>
                              {j?.name} - {j?.defect_count}
                            </p>
                            <br />
                          </Fragment>
                        ))}
                      </TableCell>
                      <TableCell>
                        {parseInt(
                          i?.batch
                            ?.random_inspection_manufacture_approval_required
                        ) === 0
                          ? "No"
                          : "Yes"}
                      </TableCell>
                      <TableCell>
                        {parseInt(i?.batch?.random_inspection_status) === 3
                          ? "Approved"
                          : "Pending"}
                      </TableCell>
                      <TableCell
                        className={`${
                          parseInt(i?.batch?.random_inspection_status) === 2 ||
                          parseInt(i?.batch?.random_inspection_status) === 3
                            ? "green"
                            : parseInt(i?.batch?.random_inspection_status) === 0
                            ? "orange"
                            : parseInt(i?.batch?.random_inspection_status) === 1
                            ? "blue"
                            : ""
                        }`}
                      >
                        {parseInt(i?.batch?.random_inspection_status) === 0
                          ? "Pending"
                          : parseInt(i?.batch?.random_inspection_status) === 1
                          ? "Started"
                          : parseInt(i?.batch?.random_inspection_status) === 2
                          ? "Completed"
                          : parseInt(i?.batch?.random_inspection_status) === 3
                          ? "Approved"
                          : ""}
                      </TableCell>
                      <TableCell>
                        {i?.batch?.random_inspection_started_by_username}
                      </TableCell>
                      <TableCell>
                        {i?.batch?.random_inspection_started_datetime} <br />{" "}
                        {i?.batch?.random_inspection_approved_datetime}
                      </TableCell>
                      <TableCell>
                        <div className="actions_basic">
                          <Button
                            onClick={(e) =>
                              handleClick(e, i?.batch?.batch_id, i?.batch)
                            }
                            className="bg__settings"
                          >
                            <img src={SettingIcon} alt="" />
                          </Button>
                          <Button
                            onClick={() =>
                              navigate(
                                `/qualitymanager/basic-audit/${i?.batch?.batch_id}`
                              )
                            }
                            style={{
                              display:
                                parseInt(i?.batch?.random_inspection_status) ===
                                  0 ||
                                parseInt(i?.batch?.random_inspection_status) ===
                                  2
                                  ? "none"
                                  : "flex",
                            }}
                            className="scan_icon"
                          >
                            <img src={ScanIcon} alt="" />
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* Basic Quantity Component ends here */}
              {/* Details Data Table Component starts here */}
              {detailsData_arr &&
                detailsData_arr.map((i, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{i.serial_code}</TableCell>
                    <TableCell>{i.size}</TableCell>
                    <TableCell>{i.color}</TableCell>
                    <TableCell>
                      {i?.defects?.map((item, index) => (
                        <React.Fragment key={index}>
                          {item}
                          {index !== i.defects.length - 1 ? (
                            (index + 1) % 2 === 0 ? (
                              <br />
                            ) : (
                              ", "
                            )
                          ) : (
                            ""
                          )}
                        </React.Fragment>
                      ))}
                    </TableCell>

                    <TableCell>
                      <Button
                        onClick={() => handleMedia(i.serial_code)}
                        className="view__media__cta"
                      >
                        View Media
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              {/* Details Data Table Component ends here */}
              {/* Size Color Data Table Component starts here */}
              {/* {sizeColor_dataArr &&
                sizeColor_dataArr.map((i, index) => {
                  console.log("VALUE: ", i);
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{i.value}</TableCell>
                      {header.slice(1).map((headerx, colIndex) => {
                        const batchData = batch_size?.[headerx.id]?.[i.id];
                        return (
                          <TableCell key={colIndex}>
                            {batchData ? `${batchData.min_inspection_qty}` : 0}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })} */}
              {/* // In DataTable.jsx */}
              {sizeColor_dataArr?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{i.value}</TableCell>
                  {header.slice(1).map((headerx, colIndex) => {
                    const batchData = batch_size?.[headerx.id]?.[i.id];
                    return (
                      <TableCell
                        key={colIndex}
                        style={{ textAlign: "center", fontWeight: "bold" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            {batchData
                              ? Math.max(
                                  parseInt(batchData.min_inspection_qty) -
                                    parseInt(batchData.inspected_qty),
                                  0
                                )
                              : 0}{" "}
                            / {batchData ? batchData.min_inspection_qty : 0}
                          </div>
                          <div
                            style={{
                              borderTop: "1px solid black",
                              width: "15%",
                              padding: "0 4px",
                            }}
                          ></div>
                          <div className="green_color">
                            <strong>
                              {" "}
                              (
                              {batchData
                                ? batchData.inspected_qty + "  Done"
                                : 0}
                              ){" "}
                            </strong>
                          </div>
                        </div>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
              {/* Size Color Data Table Component starts here */}
              {/* general Data Table Component starts here */}

              {general__data &&
                general__data.map((i, index) => {
                  const defectStatus = rowEvalDefects
                    ? rowEvalDefects[`row_${i.id}`]
                    : undefined;

                  // console.log()
                  const defectText =
                    defectStatus?.is_defect === 1
                      ? "Yes"
                      : defectStatus?.is_defect === 0
                      ? "No"
                      : "";

                  const severityText = defectStatus?.severity_name || "";
                  const tolerance_name = defectStatus?.tolerance_name || "";

                  return (
                    <TableRow
                      className="history-table general__data table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{i.name}</TableCell>
                      <TableCell>
                        {i?.defect_severity?.name || i?.point_a}
                      </TableCell>
                      <TableCell>
                        {i?.defect_type?.name || i?.point_b}
                      </TableCell>
                      {isMeasurement_table ? (
                        <>
                          <TableCell>{tolerance_name || "-"}</TableCell>
                        </>
                      ) : (
                        ""
                      )}
                      <TableCell className="left__align">
                        {parseInt(i.value_type) === 1 ? (
                          <Dropdown
                            placeholder="Score"
                            dropdown={OPTION_ARR}
                            // value={
                            //   inspectionPoints.find(
                            //     (point) =>
                            //       parseInt(point.defect_id) === parseInt(i.id)
                            //   )?.label || ""
                            // }
                            onData={(value) =>
                              handleInputChange(
                                value?.value,
                                i?.id,
                                is_measurement ? 1 : 0,
                                i?.image_required,
                                value?.label
                              )
                            }
                          />
                        ) : (
                          <input
                            className="input__row_dTable"
                            type="number"
                            placeholder="Score"
                            value={
                              inspectionPoints.find(
                                (point) =>
                                  parseInt(point.defect_id) === parseInt(i.id)
                              )?.input || ""
                            }
                            style={{
                              border:
                                eval_defect === 1 && focusedInput === i.id
                                  ? "1px solid red"
                                  : // : eval_defect === 0 && focusedInput === i.id
                                    // ? "1px solid transparent"
                                    "none",
                            }}
                            onFocus={() => setFocusedInput(i.id)} // Track focus
                            onBlur={() => setFocusedInput(null)}
                            onChange={(e) => {
                              handleInputChange(
                                e.target.value,
                                i.id,
                                is_measurement ? 1 : 0,
                                i.image_required
                              );
                            }}
                          />
                        )}
                      </TableCell>
                      {isMeasurement_table ? (
                        <>
                          <TableCell>{defectText}</TableCell>
                          <TableCell>{severityText}</TableCell>
                        </>
                      ) : (
                        ""
                      )}
                      <TableCell>
                        {/* {parseInt(i.image_required) === 1 ? ( */}
                        <>
                          {inspectionPoints.find(
                            (point) =>
                              parseInt(point.defect_id) === parseInt(i.id)
                          )?.file ? (
                            <img
                              className="img__col"
                              src={
                                inspectionPoints.find(
                                  (point) =>
                                    parseInt(point.defect_id) === parseInt(i.id)
                                )?.file
                              }
                              alt="Uploaded"
                            />
                          ) : (
                            <>
                              <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                id={`file_input-${i.id}`} // Unique ID for each row
                                onChange={(e) =>
                                  handleFileChange(
                                    e,
                                    i.id,
                                    is_measurement ? 1 : 0
                                  )
                                }
                              />
                              <Button
                                className="upload__image__cta"
                                onClick={() =>
                                  document
                                    .getElementById(`file_input-${i.id}`)
                                    .click()
                                }
                              >
                                Upload Image&nbsp; <br />
                                <span className="red__required">
                                  {parseInt(i.image_required) === 1 ? "*" : ""}
                                </span>
                              </Button>
                            </>
                          )}
                        </>
                        {/* ) : ( */}
                        {/* <p style={{ color: "#E52020" }}>No Image Required*</p> */}
                        {/* )} */}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* general Data Table Component ends here */}

              {/* Previously Scanned Serial Code component starts here */}
              {PreviousSerial_Data?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{i?.bbsc?.code}</TableCell>
                  <TableCell>{i?.bbsc?.created}</TableCell>
                  <TableCell>
                    {i?.user?.firstname} {i?.user?.lastname}
                  </TableCell>
                  <TableCell>
                    {i?.bbsc?.is_label_downloaded
                      ? "Downloaded"
                      : "Not Downloaded"}
                  </TableCell>
                  <TableCell>
                    <div className="downloaded__cta_container">
                      <Button
                        onClick={() => handleDownloadLabel(i?.bbsc?.id)}
                        className="downloaded__cta"
                      >
                        Re-Download Label
                      </Button>
                      {/* <Button className="downloadeds__cta">
                        Re-Download MRP
                      </Button> */}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
              {/* Previously Scanned Serial Code component ends here */}

              {/* Cutting Summary Component starts here */}
              {CuttingSummaryData &&
                CuttingSummaryData.map((item, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>
                      {" "}
                      {(page - 1) * items_per_page + index + 1}
                    </TableCell>
                    <TableCell>{item?.manufacture_primary_location}</TableCell>
                    <TableCell>{item?.batch_name}</TableCell>
                    <TableCell>
                      <img
                        alt="assign"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "100%",
                        }}
                        src={item?.product_group_image}
                      />{" "}
                      <br />
                      {item?.product_group_name}
                    </TableCell>
                    <TableCell>{item?.manufacture_order?.qty}</TableCell>
                    <TableCell>{item?.batch_qty || "-"}</TableCell>
                    <TableCell>
                      {item?.manufacture_order_size_ratio
                        ?.map((e) => {
                          return `${e.name}:${e.ratio}`;
                        })
                        .join(", ")}
                    </TableCell>
                    <TableCell>
                      {item?.manufacture_order_color_ratio
                        ?.map((e) => {
                          return `${e?.name}:${e?.ratio}`;
                        })
                        .join(", ")}
                    </TableCell>
                    <TableCell>
                      {item?.manufacture_order_brand_ratio
                        ?.map((e) => {
                          return `${e?.name}:${e?.ratio}`;
                        })
                        .join(", ")}
                    </TableCell>
                    <TableCell>{item?.manufacture_style}</TableCell>
                    <TableCell>
                      {item?.manufacture_order_created_by ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.manufacture_order_created_by_profile_image
                              }
                              alt="assign"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "100%",
                              }}
                            />
                          </div>
                          <p>{item?.manufacture_order_created_by}</p>
                          <p>
                            {item?.manufacture_order?.created &&
                              new Date(
                                item?.manufacture_order?.created
                              ).toLocaleDateString("en-US", {
                                year: "2-digit",
                                month: "short",
                                day: "2-digit",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      {item?.manufacture_order_picked_by ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.manufacture_order_picked_by_profile_image
                              }
                              alt="assign"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "100%",
                              }}
                            />
                          </div>
                          <p>{item?.manufacture_order_picked_by}</p>
                          <p>
                            {item?.manufacture_order?.picked_on &&
                              new Date(
                                item?.manufacture_order?.picked_on
                              ).toLocaleDateString("en-US", {
                                year: "2-digit",
                                month: "short",
                                day: "2-digit",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      {item?.manufacture_order_complete_req_by ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.manufacture_order_complete_req_by_profile_image
                              }
                              alt="assign"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "100%",
                              }}
                            />
                          </div>
                          <p>{item?.manufacture_order_complete_req_by}</p>
                          <p>
                            {item?.manufacture_order
                              ?.is_complete_noti_sent_datetime &&
                              new Date(
                                item?.manufacture_order?.is_complete_noti_sent_datetime
                              ).toLocaleDateString("en-US", {
                                year: "2-digit",
                                month: "short",
                                day: "2-digit",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      {item?.manufacture_order_completed_by ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.manufacture_order_completed_by_profile_image
                              }
                              alt="assign"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "100%",
                              }}
                            />
                          </div>
                          <p>{item?.manufacture_order_completed_by}</p>
                          <p>
                            {item?.manufacture_order?.complete_datetime &&
                              new Date(
                                item?.manufacture_order?.complete_datetime
                              ).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "2-digit",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>{item?.bundle_qty || "-"}</TableCell>

                    <TableCell>
                      <div className="table-actions relative">
                        <button
                          onClick={() => {
                            setOpenRowIndex((prevIndex) =>
                              prevIndex === index ? null : index
                            ); // Toggle logic for each row
                          }}
                          style={{
                            backgroundColor: "#2C2C2C",
                            color: "#fff",
                            padding: "0.5rem",
                            borderRadius: "0.3rem",
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{ width: "1.25rem", height: "1.25rem" }}
                          >
                            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </button>

                        {openRowIndex === index && (
                          <div className="options-container">
                            {/* {item?.manufacture_order?.journey_status !==
                              "3" && ( */}
                            <p
                              className="option-link"
                              onClick={() =>
                                navigate(
                                  `/journey/${item?.manufacture_order?.id}/${item?.manufacture_order?.journey_status}`
                                )
                              }
                            >
                              Journey
                            </p>
                            {/* )} */}
                            <p
                              className="option-link"
                              onClick={() => {
                                handlePickToggle(
                                  item?.manufacture_order?.id,
                                  parseInt(item?.manufacture_order?.picked_by)
                                );
                                setOpenRowIndex(null); // Close after action
                              }}
                            >
                              {item?.manufacture_order?.picked_by === "0"
                                ? "Pick"
                                : "Unpick"}
                            </p>
                            <p
                              className="option-link"
                              onClick={() => {
                                setIsIndex(13);
                                setManufactureOrderId(
                                  item?.manufacture_order?.id
                                );
                              }}
                            >
                              Add Challan
                            </p>
                            <p
                              className="option-link"
                              onClick={() => {
                                setModalId(item?.manufacture_order?.id);
                                setIsIndex(9);
                                setOpenRowIndex(null); // Close after action
                              }}
                            >
                              Add Comment
                            </p>
                            <p
                              className="option-link"
                              onClick={() => {
                                setModalId(item?.manufacture_order?.id);
                                setIsIndex(10);
                                setOpenRowIndex(null); // Close after action
                              }}
                            >
                              View Comment
                            </p>
                            {item?.manufacture_order?.journey_status ===
                              "3" && (
                              <p
                                className="option-link"
                                onClick={() => {
                                  handleNotify(item?.manufacture_order?.id);
                                  setOpenRowIndex(null); // Close after action
                                }}
                              >
                                Notify Completion
                              </p>
                            )}
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              {/* Cutting Summary Component ends here */}

              {/* Fabric Estimation Data Component starts here */}
              {EstimationData &&
                EstimationData.map((item, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{item?.sr_no}</TableCell>
                    <TableCell>{item?.ManufactureOrderCut?.name}</TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut?.type === "1"
                        ? "Main"
                        : "Auxillary"}
                    </TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut?.avg_weight_per_piece}
                    </TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut
                        ?.practical_avg_weight_per_piece || "-"}
                    </TableCell>

                    <TableCell>
                      {item?.ManufactureOrderCutSize.map((e) => {
                        return `${e.size}:${e.ratio}:${e.qty}`;
                      }).join(", ")}
                    </TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut?.weight_of_one_layer}
                    </TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut
                        ?.fabric_estimation_req_by_username ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.ManufactureOrderCut
                                  ?.fabric_estimation_req_by_profile_image
                              }
                              alt="assign"
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "100%",
                              }}
                            />
                          </div>
                          <p>
                            {
                              item?.ManufactureOrderCut
                                ?.fabric_estimation_req_by_username
                            }
                          </p>
                          <p>
                            {item?.ManufactureOrderCut
                              ?.fabric_estimation_requested_on &&
                              new Date(
                                item?.ManufactureOrderCut?.fabric_estimation_requested_on
                              )?.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      {item?.ManufactureOrderCut?.approve_by_username ? (
                        <>
                          <div
                            className="user-container"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={
                                item?.ManufactureOrderCut
                                  ?.approve_by_profile_image
                              }
                              alt="assign"
                              style={{ width: "2.5rem", borderRadius: "100%" }}
                            />
                          </div>
                          <p>
                            {item?.ManufactureOrderCut?.approve_by_username}
                          </p>
                          <p>
                            {item?.ManufactureOrderCut?.approve_datetime &&
                              new Date(
                                item?.ManufactureOrderCut?.approve_datetime
                              )?.toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                              })}
                          </p>
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "block",
                          width: "200px",
                          gap: "1rem",
                        }}
                      >
                        {item?.ManufactureOrderCut?.is_approved === false && (
                          <button
                            style={{
                              backgroundColor: "#7D95C9",
                              color: "#fff",
                              padding: "0.5rem 1rem",
                              borderRadius: "2px",
                              cursor: "pointer",
                              fontFamily: "Poppins_medium",
                              fontSize: "0.8rem",
                            }}
                            onClick={() => {
                              setIsIndex(12);
                              setModalId(item?.ManufactureOrderCut?.id);
                            }}
                          >
                            Add CAD Marker
                          </button>
                        )}
                        <button
                          style={{
                            backgroundColor: "#3C94C6",
                            color: "#fff",
                            padding: "0.5rem 1rem",
                            borderRadius: "2px",
                            cursor: "pointer",
                            fontFamily: "Poppins_medium",
                            fontSize: "0.8rem",
                            marginTop: "5px",
                          }}
                          onClick={() => {
                            setIsIndex(8);
                            setModalId(item?.ManufactureOrderCut?.id);
                          }}
                        >
                          View Marker
                        </button>
                        {item?.ManufactureOrderCut?.is_approved === false && (
                          <button
                            style={{
                              backgroundColor: "#2ED47E",
                              color: "#fff",
                              padding: "0.5rem 1rem",
                              borderRadius: "2px",
                              cursor: "pointer",
                              fontFamily: "Poppins_medium",
                              fontSize: "0.8rem",
                              marginTop: "5px",
                            }}
                            onClick={() => {
                              setIsIndex(11);
                              setModalId(item?.ManufactureOrderCut?.id);
                            }}
                          >
                            Request for Approval
                          </button>
                        )}
                        <button
                          style={{
                            backgroundColor: "#ff0000",
                            color: "#fff",
                            padding: "0.5rem 1rem",
                            borderRadius: "2px",
                            cursor: "pointer",
                            fontFamily: "Poppins_medium",
                            fontSize: "0.8rem",
                            marginTop: "5px",
                            marginLeft: "5px",
                          }}
                          onClick={() => {
                            setModalId(item?.ManufactureOrderCut?.id);
                            handleCutDelete(item?.ManufactureOrderCut?.id);
                          }}
                        >
                          {delLoading &&
                          item?.ManufactureOrderCut?.id === modalId ? (
                            <Loading
                              loading={
                                delLoading &&
                                item?.ManufactureOrderCut?.id === modalId
                              }
                              color={"#1c1c1c"}
                              size={18}
                            />
                          ) : (
                            "Delete"
                          )}
                        </button>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              {/* Fabric Estimation Data Component ends here */}

              {/* View Cad Marker Component Starts here */}
              {viewcad &&
                viewcad.map((item, index) => (
                  <TableRow
                    className="history-table table-container-wrapper"
                    key={index}
                  >
                    <TableCell>{item?.MC?.estimation_weight}</TableCell>
                    <TableCell>
                      {item?.MC?.created &&
                        new Date(item?.MC?.created)?.toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "short",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                    </TableCell>
                    <TableCell>
                      <button
                        className="cad-btn"
                        onClick={() => {
                          window.open(
                            // eslint-disable-next-line
                            `${baseDomain}` + "/" + item?.MC?.cad,
                            // eslint-disable-next-line
                            "_blank"
                          );
                        }}
                      >
                        Preview File
                      </button>
                    </TableCell>
                  </TableRow>
                ))}
              {/* View Cad Marker Component ends here */}

              {/* View Comment Component starts here */}
              {Array.isArray(viewcomment) &&
                viewcomment?.map((item, index) => {
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{item?.MOC?.comment}</TableCell>
                      <TableCell>
                        {item?.MOC?.created &&
                          new Date(item?.MOC?.created)?.toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            }
                          )}
                      </TableCell>
                      <TableCell>
                        {/* <button
                      className="cad-btn"
                      onClick={() => {
                        window.open(
                          localStorage.getItem("baseurl") + "/" + item?.MC?.cad,
                          "_blank"
                        );
                      }}
                    >
                      Preview File
                    </button> */}
                        {item?.MOCI?.map((img, i) => (
                          <img
                            key={i}
                            src={img?.link}
                            alt={item?.MOC?.created}
                            style={{ width: "80px", height: "80px" }}
                          />
                        ))}
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* View Comment Component ends here */}

              {/* View Challan Component starts here */}
              {Array.isArray(challan_data) &&
                challan_data?.map((item, index) => {
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{item?.challan_no}</TableCell>
                      <TableCell>{item?.created}</TableCell>
                      <TableCell>{item?.modified}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() => handleDeleteChallan(index, item?.id)}
                          className="delete__cta"
                        >
                          {deleteChallan__loading &&
                          index === isActiveChallan ? (
                            <Loading
                              loading={deleteChallan__loading}
                              color={"white"}
                              size={14}
                            />
                          ) : (
                            <Delete />
                          )}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* View Challan Component ends here */}

              {/* Master Data Component starts here */}
              {Array.isArray(MasterData) &&
                MasterData?.map((item, index) => {
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{item?.challan_no}</TableCell>
                      <TableCell>{item?.product_sub_group_name}</TableCell>
                      <TableCell>
                        <img src={item?.image} alt="" />
                      </TableCell>
                      <TableCell>{item?.batch_audit_min_percentage}</TableCell>
                      <TableCell>{item?.product_construction_types}</TableCell>
                      <TableCell></TableCell>
                      <TableCell>{item?.garment_fit}</TableCell>
                    </TableRow>
                  );
                })}
              {/* Master Data Component ends here */}

              {/* Batches Data Component starts here */}
              {Array.isArray(batches) &&
                batches?.map((item, index) => {
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <img
                          className="img-col"
                          src={item.product_group_image}
                          alt=""
                        />
                        <br />
                        {item.product_group_name}
                      </TableCell>
                      <TableCell>{item.batch_name}</TableCell>
                      <TableCell>{item?.qty}</TableCell>
                      <TableCell>
                        <Link
                          onClick={() => handleBatchDetails(16, item.batch_id)}
                        >
                          {item?.total_finished_qty}
                        </Link>
                      </TableCell>
                      <TableCell>{item?.pending_qty}</TableCell>
                    </TableRow>
                  );
                })}
              {/* Batches Data Component ends here */}

              {/* Batch Details Data Component starts here */}
              {Array.isArray(batchDetails) &&
                batchDetails?.map((item, index) => {
                  return (
                    <TableRow
                      className="history-table table-container-wrapper"
                      key={index}
                    >
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.pending}</TableCell>
                      <TableCell>{item?.aging}</TableCell>
                      <TableCell>{item?.hold_qty}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() =>
                            handleMarkHold(index, item?.process_node_id)
                          }
                          className="mark__hold"
                        >
                          {activeMarkHoldIndex === index && markHoldLoading ? (
                            <Loading
                              loading={markHoldLoading}
                              color={"white"}
                              size={14}
                            />
                          ) : (
                            "Mark Hold"
                          )}
                        </Button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {/* Batch Details Data Component ends here */}

              {/* Date Wise Component starts here */}
              {productConsolidatedReport?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {/* Fixed columns */}
                  <TableCell>
                    <img className="icon-picture" src={row?.key_img} alt="" />
                    <br />
                    {row.key_name}
                  </TableCell>
                  <TableCell>{row.date}</TableCell>

                  {/* Dynamic operation columns */}
                  {header?.subRow?.map((op) => {
                    const found = row.detail.find(
                      (d) => d.operation_type_id === String(op.id)
                    );
                    return (
                      <TableCell key={op.id} align="center">
                        {found ? (
                          <div className="grid__table__row">
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>O/B</strong> {found.wip_opening_qty || 0}
                            </div>
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>C/B</strong> {found.wip_closing_qty || 0}
                            </div>
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>SOH</strong> {found.days_of_cover || 0}
                            </div>
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>MP</strong>{" "}
                              {found.available_user_ids || 0}
                            </div>
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>PROD</strong> {found.production_qty || 0}
                            </div>
                            <div
                              style={{
                                border: "1px solid rgba(217, 217, 217, 1)",
                              }}
                            >
                              <strong>NWIP</strong> {found.net_wip || 0}
                            </div>
                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
              {/* Date Wise Component ends here */}

              {/* Hourly Consolidated Component starts here */}
              {/* {hourlyConsolidatedReport?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{i?.operation_type}</TableCell>
                  <TableCell>
                    <img className="icon-picture" src={i.key_img} alt="" />
                    <br /> {i.key_name}
                  </TableCell>
                  <TableCell>{i.date}</TableCell>

                  Time Columns 9AM - 6PM
                  {Array.from({ length: 9 }, (_, idx) => {
                    const hour = 9 + idx;
                    const detailItem = i.detail?.find((d) => {
                      const fromHour = new Date(
                        d.manufacture_datetime_from
                      ).getHours();
                      return fromHour === hour;
                    });

                    return (
                      <TableCell key={hour}>
                        {detailItem ? (
                          <div>
                            <div>{detailItem.production_qty || 0} Units</div>
                            Add other fields as needed
                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))} */}

              {hourlyConsolidatedReport?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{i?.operation_type}</TableCell>
                  <TableCell>
                    <img className="icon-picture" src={i.key_img} alt="" />
                    <br /> {i.key_name}
                  </TableCell>
                  <TableCell>{i.date}</TableCell>

                  {/* Time Columns: 00 - 23 (24 Hours) */}
                  {Array.from({ length: 24 }, (_, hour) => {
                    const detailItem = i.detail?.find((d) => {
                      const fromHour = new Date(
                        d.manufacture_datetime_from
                      ).getHours();
                      return fromHour === hour;
                    });

                    return (
                      <TableCell key={hour}>
                        {detailItem ? (
                          <div>
                            <div>{detailItem.production_qty || 0} Units</div>
                            {/* you can show other details here, e.g. d.manufacture_datetime_from */}
                          </div>
                        ) : (
                          "-"
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}

              {/* Hourly Consolidated Component ends here */}

              {/* Sub order Summary Component starts here */}
              {subOrderSummary?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{i.sub_order_code || "-"}</TableCell>
                  <TableCell>
                    {i.sub_order_created_by} <br /> {i.sub_order_created_on}
                  </TableCell>
                  <TableCell>{i.planned_qty}</TableCell>
                  <TableCell>{i.sku_count}</TableCell>
                  <TableCell>{i.group_count}</TableCell>
                  <TableCell>
                    {Math.abs(
                      parseInt(i.planned_qty) - parseInt(i.packing_scanned_qty)
                    )}
                  </TableCell>
                  <TableCell>
                    {Math.abs(
                      parseInt(i.planned_qty) - parseInt(i.pfs_scanned_qty)
                    )}
                  </TableCell>
                  <TableCell>
                    {Math.abs(
                      parseInt(i.planned_qty) - parseInt(i.cutting_scanned_qty)
                    )}
                  </TableCell>
                  <TableCell>
                    <Button
                      onClick={() =>
                        navigate("/suborder-local-view-consolidated")
                      }
                      className="view-summary"
                    >
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {/* Sub order summary Component ends here */}

              {/* Temp Hold Summary Component starts here */}
              {TempHoldSummary?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>
                    {i?.pg_image && (
                      <img className="icon-picture" src={i?.pg_image} alt="" />
                    )}{" "}
                    <br />
                    {i?.category_style_color && i?.category_style_color} <br />
                    {i?.sku && i?.sku}
                  </TableCell>
                  <TableCell>{i.hold_created}</TableCell>
                  <TableCell>
                    {i.hold_from_datetime} <br /> {i.hold_to_datetime}
                  </TableCell>
                  <TableCell>
                    <strong
                      style={{
                        color: i.hold_status
                          ? "rgba(70, 204, 141, 1)"
                          : "rgba(255, 0, 0, 1)",
                      }}
                    >
                      {i.hold_status ? "Active" : "Inactive"}
                    </strong>
                  </TableCell>
                  <TableCell>{i.location_name}</TableCell>
                  <TableCell>{i.sub_location_name}</TableCell>
                  <TableCell>{i.active_hold_count}</TableCell>
                  <TableCell>
                    <Button
                      onClick={() => handleDeactivate(index, i?.hold_id)}
                      className="deactivate__hold"
                    >
                      {tempHold__Loading && index === isActiveTemp ? (
                        <Loading
                          loading={tempHold__Loading}
                          color={"white"}
                          size={14}
                        />
                      ) : (
                        "Deactivate Hold"
                      )}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {/* Temp Hold Summary Component ends here */}

              {/* Temp Hold Summary Component starts here */}
              {Array.isArray(portalNetInventory) &&
              portalNetInventory.length > 0
                ? portalNetInventory.map((i, index) => (
                    <TableRow key={i.id || index}>
                      <TableCell>
                        {index + 1 + (page - 1) * items_per_page}
                      </TableCell>
                      <TableCell>
                        <img className="icon-picture" src={i?.image} alt="" />
                        <br />
                        <Link
                          onClick={() =>
                            handleAlternateModal(i.alternate_sku_detail)
                          }
                        >
                          {i?.sku}
                        </Link>
                      </TableCell>
                      <TableCell>{i?.sync_number}</TableCell>
                      <TableCell>{i?.date}</TableCell>
                      <TableCell>{i?.available_qty}</TableCell>
                      <TableCell>{i?.blocked_location_qty}</TableCell>
                      <TableCell>
                        <Link
                          onClick={() =>
                            handlePortalInventPopup(i?.sync_number, i?.key_id)
                          }
                        >
                          {i?.external_location_qty}
                        </Link>
                      </TableCell>
                      <TableCell>{i?.temp_hold_qty}</TableCell>
                      <TableCell>{i?.out_not_in_qty}</TableCell>
                      <TableCell>{i?.in_not_out_qty}</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>{i?.shipment_qty}</TableCell>
                      <TableCell>{i?.picklist_pending_qty}</TableCell>
                      <TableCell>
                        {/* {(Number(i?.available_qty) || 0) -
                          (Number(i?.temp_hold_qty) || 0) +
                          (Number(i?.out_not_in_qty) || 0) +
                          (Number(i?.in_not_out_qty) || 0) -
                          (Number(i?.shipment_qty) || 0) -
                          (Number(i?.picklist_pending_qty) || 0)} */}
                        {i?.net_avaiable_wip}
                      </TableCell>
                      <TableCell>{i?.net_avaiable_warehouse}</TableCell>
                    </TableRow>
                  ))
                : null}

              {/* Temp Hold Summary Component ends here */}

              {/* Sub order Level View Consolidated component starts here */}
              {suborderLevelViewConsolidated?.map((i, index) => (
                <TableRow key={index}>
                  {/* Sr.No. */}
                  <TableCell>{index + 1}</TableCell>

                  {/* Sku Code */}
                  <TableCell>
                    <img src={i.image} alt="" />
                    <br />
                    {i.key_name}
                  </TableCell>

                  {/* Opening Qty */}
                  <TableCell>{i.opening_qty ?? "-"}</TableCell>

                  {/* dynamic cells here */}
                  {dynamicSubOrderCols.map((col) => {
                    const matched = i.sub_orders.find(
                      (s) => s.sub_order_id === col.id
                    );
                    return (
                      <TableCell key={col.id}>
                        {matched
                          ? (() => {
                              const planned = Number(matched.planned_qty) || 0;
                              const packingScanned = Math.min(
                                planned,
                                Number(matched.packing_scanned_qty) || 0
                              );
                              const cuttingScanned = Math.min(
                                planned,
                                Number(matched.cutting_scanned_qty) || 0
                              );
                              const pfsScanned = Math.min(
                                planned,
                                Number(matched.pfs_scanned_qty) || 0
                              );

                              return (
                                <>
                                  Planned: {planned} <br />
                                  Packing: {packingScanned} <br />
                                  Cutting: {cuttingScanned} <br />
                                  PFS: {pfsScanned}
                                </>
                              );
                            })()
                          : "-"}
                      </TableCell>
                    );
                  })}

                  {/* Pending / Aging columns */}
                  {/* <TableCell>
                    Pack: {i?.product_level_count?.packing_scanned_qty || 0}{" "}
                    <br />
                    PFS: {i?.product_level_count?.pfs_scanned_qty || 0} <br />
                    Cut: {i?.product_level_count?.cutting_scanned_qty || 0}
                  </TableCell> */}

                  <TableCell>
                    {(() => {
                      const planned = Number(i?.planned_qty) || 0;

                      const pack = Math.min(
                        planned,
                        Math.max(
                          0,
                          Number(i?.product_level_count?.packing_scanned_qty) ||
                            0
                        )
                      );
                      const pfs = Math.min(
                        planned,
                        Math.max(
                          0,
                          Number(i?.product_level_count?.pfs_scanned_qty) || 0
                        )
                      );
                      const cut = Math.min(
                        planned,
                        Math.max(
                          0,
                          Number(i?.product_level_count?.cutting_scanned_qty) ||
                            0
                        )
                      );

                      return (
                        <>
                          Pack: {pack} <br />
                          PFS: {pfs} <br />
                          Cut: {cut}
                        </>
                      );
                    })()}
                  </TableCell>

                  <TableCell>
                    {i?.aging?.last_7_days_planned_qty || 0}
                  </TableCell>
                  <TableCell>
                    {i?.aging?.between_7_and_14_days_planned_qty || 0}
                  </TableCell>
                  <TableCell>
                    {i?.aging?.between_15_and_30_days_planned_qty || 0}
                  </TableCell>
                  <TableCell>
                    {i?.aging?.between_30_and_60_days_planned_qty || 0}
                  </TableCell>
                  <TableCell>
                    {i?.aging?.more_than_60_days_planned_qty || 0}
                  </TableCell>
                </TableRow>
              ))}
              {/* Sub order Level View Consolidated component ends here */}

              {/* ALternate SKU Component starts here */}
              {Array.isArray(alternateSKU) && alternateSKU?.length > 0
                ? alternateSKU?.map((i, index) => (
                    <TableRow key={i.id || index}>
                      <TableCell>{i?.available_qty}</TableCell>
                      <TableCell>{i?.blocked_location_qty}</TableCell>
                      <TableCell>{i?.out_not_in_qty}</TableCell>
                      <TableCell>{i?.in_not_out_qty}</TableCell>
                      <TableCell>{i?.picklist_pending_qty}</TableCell>
                      <TableCell>{i?.shipment_qty}</TableCell>
                      <TableCell>{i?.temp_hold_qty}</TableCell>
                      {/* <TableCell>
                        <img className="icon-picture" src={i?.image} alt="" />
                        <br />
                        <Link
                          onClick={() =>
                            handleAlternateModal(i.alternate_sku_detail)
                          }
                        >
                          {i?.sku}
                        </Link>
                      </TableCell> */}
                    </TableRow>
                  ))
                : null}
              {/* Alternate SKU Component ends here */}

              {/* Missing Inventory Component starts here */}
              {Array.isArray(missingInventoryList) &&
              missingInventoryList?.length > 0
                ? missingInventoryList.map((i, index) => {
                    // Party icons mapping (lowercase keys)
                    const partyIcons = {
                      meesho: meeshoIcon,
                      myntra: myntraIcon,
                      snapdeal: snapdealIcon,
                      flipkart: flipkartIcon,
                      amazon: amazonIcon,
                    };

                    return (
                      <TableRow key={i.id || index}>
                        <TableCell>
                          {index + 1 + (page - 1) * items_per_page}
                        </TableCell>

                        <TableCell>
                          <img className="icon-picture" src={i?.image} alt="" />
                        </TableCell>

                        <TableCell>{i?.category_style_color}</TableCell>

                        <TableCell>
                          {i?.category_name} <br /> {i?.category_style_color}{" "}
                          <br /> {i?.product_group_name} <br /> {i?.trends}
                        </TableCell>

                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>

                        <TableCell>{i?.qty_last_7_days}</TableCell>
                        <TableCell>{i?.qty_last_30_days}</TableCell>
                        <TableCell>{i?.qty_last_60_days}</TableCell>

                        <TableCell></TableCell>

                        <TableCell>
                          {i?.listings?.length > 0
                            ? "Listing Done"
                            : "No Listing Done"}
                        </TableCell>

                        <TableCell>
                          {/* Show all icons for all listings */}
                          <div className="listing__img__row">
                            {Array.isArray(i.listings) &&
                              i.listings.map((listing, idx) => {
                                const partyName = listing.party?.toLowerCase();
                                const iconSrc = partyIcons[partyName];
                                return iconSrc ? (
                                  <div>
                                    <img
                                      key={idx}
                                      className="icon-picture"
                                      src={iconSrc}
                                      alt={listing.party}
                                      // style={{ marginRight: "5px" }}
                                    />
                                    <p>{listing?.party_id}</p>
                                  </div>
                                ) : null;
                              })}
                          </div>
                        </TableCell>

                        <TableCell>{i?.launch_date || "-"}</TableCell>
                        <TableCell>{i?.aging}</TableCell>
                      </TableRow>
                    );
                  })
                : null}
              {/* Missing Inventory Component ends here */}

              {/* Portal Net Inventory Popup Component starts here */}
              {PortalNetInventPopup?.map((i, index) => (
                <TableRow
                  className="history-table table-container-wrapper"
                  key={index}
                >
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{i?.location_name}</TableCell>
                  <TableCell>{i?.qty}</TableCell>
                </TableRow>
              ))}
              {/* Portal Net Inventory Popup Component ends here */}
            </TableBody>
          </Table>
        </TableContainer>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {Menu_arr.filter((menuItem) => {
            const status = parseInt(
              inspection_status?.random_inspection_status
            );
            if (status === 0) {
              return ![2, 4].includes(menuItem.id);
            }
            if (status === 1) {
              return ![2, 3].includes(menuItem.id);
            }
            if (status === 2) {
              return ![3, 4].includes(menuItem.id);
            }
            if (status === 3) {
              return ![2, 3, 4].includes(menuItem.id);
            }
            return true;
          }).map((menuItem) => (
            <MenuItem
              key={menuItem.id}
              className="menu__items"
              onClick={() =>
                handleClose(menuItem.id, inspection_status?.batch_id)
              }
            >
              {menuItem.title}
            </MenuItem>
          ))}
        </Menu>
      </Fragment>
    );
  }
);

export default DataTable;
